// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module AnalyticsDashboard
 * @package @geenius/analytics/react-css
 * @description Publishes the React CSS dashboard composition through the
 * component catalog while delegating rendering to the route-ready dashboard
 * page implementation.
 */

import type React from "react";
import {
  AnalyticsDashboardPage,
  type AnalyticsDashboardPageProps,
} from "../pages/AnalyticsDashboardPage";

/** Props accepted by the public React CSS analytics dashboard component. */
export type AnalyticsDashboardProps = AnalyticsDashboardPageProps;

/**
 * Renders the canonical React CSS analytics dashboard as a component export.
 *
 * @param props Dashboard data, realtime state, and page composition options.
 * @returns The React CSS analytics dashboard surface.
 */
export function AnalyticsDashboard(
  props: AnalyticsDashboardProps,
): React.ReactElement {
  return <AnalyticsDashboardPage {...props} />;
}
